import { apiError } from './constants/error-types';
import { CashfreeException } from './exception-helper';

const cacheObj = {};

const NetworkOnly = async (url, data = {}) => {
    const response = await fetch(url, data);
    if (response.status !== 200) {
        const failedRes = await response.json();
        throw new CashfreeException(failedRes.message, apiError, null , failedRes.code);
    }
    const responseJson = await response.json();
    return responseJson;
};

const CacheFirst = async (url, data = {}) => {
    const cachedResponse = cacheObj[url];
    if (cachedResponse) return cachedResponse;

    const response = await fetch(url, data);
    if (response.status !== 200) {
        const failedRes = await response.json();
        throw new CashfreeException(failedRes.message, apiError);
    }
    const responseJson = await response.json();
    cacheObj[url] = responseJson;
    return responseJson;
};

export { NetworkOnly, CacheFirst };
